import React, { useState } from 'react';
import { Lock, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async event => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/');
    } catch {
      setError('Credenciales incorrectas.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="suite-login">
      <section className="suite-login-form" aria-labelledby="suite-login-title">
        <div className="suite-login-card">
          <img
            src="/logo.png?v=3"
            className="suite-login-logo"
            alt="Hoprin+"
          />
          <h1 id="suite-login-title" className="suite-login-brand-name">Suite Empresarial</h1>
          <p className="suite-login-tagline">Ingresa tus credenciales para acceder al sistema</p>

          {error && <div className="suite-login-alert" role="alert">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="suite-login-field">
              <Mail className="suite-login-input-icon" size={18} aria-hidden="true" />
              <input
                className="suite-login-input"
                type="email"
                value={email}
                onChange={event => setEmail(event.target.value)}
                placeholder="Correo electrónico"
                autoComplete="email"
                required
                autoFocus
              />
            </div>

            <div className="suite-login-field">
              <Lock className="suite-login-input-icon" size={18} aria-hidden="true" />
              <input
                className="suite-login-input"
                type="password"
                value={password}
                onChange={event => setPassword(event.target.value)}
                placeholder="Contraseña"
                autoComplete="current-password"
                required
              />
            </div>

            <label className="suite-login-remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={event => setRemember(event.target.checked)}
              />
              <span>Recordarme</span>
            </label>

            <button className="suite-login-submit" type="submit" disabled={loading}>
              {loading ? 'Validando...' : 'Iniciar Sesión'}
              {!loading && <ArrowRight size={18} aria-hidden="true" />}
            </button>
          </form>

          <p className="suite-login-forgot">
            <a href="https://sistema.hoprinplus.com/password/reset">¿Olvidaste tu contraseña?</a>
          </p>
        </div>
      </section>
      <aside className="suite-login-image" aria-hidden="true" />
    </main>
  );
}

